/**
 * Registre des 9 numéros pédagogiques du programme ETM.
 *
 * Seul le numéro EPI (n°7) est publié dans cette première version.
 * Les autres sont déclarés en placeholder `status: 'coming-soon'` pour
 * afficher la grille complète des 9 numéros sur la page d'accueil
 * et donner à l'élève la vision du programme.
 */

import { epiEtmIssue } from './epi';
import { conducteurEtmIssue } from './conducteur';
import { premiersSecoursEtmIssue } from './premiers-secours';
import { mecaniqueEtmIssue } from './mecanique';
import { routeEtmIssue } from './route';
import { circulationEtmIssue } from './circulation';
import { autresUsagersEtmIssue } from './autres-usagers';
import { notionsDiversesEtmIssue } from './notions-diverses';
import { environnementEtmIssue } from './environnement';

// Métadonnées légères pour la grille / index (sans charger tout le contenu)
export const ETM_ISSUES_INDEX = [
  {
    number: 1,
    slug: 'route',
    themeCode: 'R',
    shortTitle: 'La route',
    title: 'Lire la route comme un motard',
    teaser: 'Signalisation, types de voies, marquages au sol — décoder ce que le bitume te dit.',
    accent: '#0891b2',
    status: 'published',
    issue: routeEtmIssue,
  },
  {
    number: 2,
    slug: 'circulation',
    themeCode: 'C',
    shortTitle: 'La circulation',
    title: 'Priorités, dépassements, intersections',
    teaser: 'Les règles qui régissent ta cohabitation avec les autres véhicules.',
    accent: '#7c3aed',
    status: 'published',
    issue: circulationEtmIssue,
  },
  {
    number: 3,
    slug: 'conducteur',
    themeCode: 'L',
    shortTitle: 'Le conducteur',
    title: 'Ton cerveau, ton meilleur EPI',
    teaser: 'Alcool, stupéfiants, fatigue, distraction — ce qui se passe vraiment dans ta tête.',
    accent: '#dc2626',
    status: 'published',
    issue: conducteurEtmIssue,
  },
  {
    number: 4,
    slug: 'autres-usagers',
    themeCode: 'U',
    shortTitle: 'Les autres usagers',
    title: 'Vivre avec piétons, vélos, camions',
    teaser: 'Le partage de la route en milieu urbain et rural — survivre à la diversité.',
    accent: '#ea580c',
    status: 'published',
    issue: autresUsagersEtmIssue,
  },
  {
    number: 5,
    slug: 'notions-diverses',
    themeCode: 'D',
    shortTitle: 'Notions diverses',
    title: 'Permis, points, assurance',
    teaser: 'Tout l\'administratif que tu dois maîtriser pour rester dans les clous.',
    accent: '#16a34a',
    status: 'published',
    issue: notionsDiversesEtmIssue,
  },
  {
    number: 6,
    slug: 'mecanique',
    themeCode: 'M',
    shortTitle: 'La mécanique',
    title: 'Une moto bien réglée, c\'est ta vie',
    teaser: 'Pneus, freins, éclairage, transmission — la check-list de pré-trajet.',
    accent: '#1d4ed8',
    status: 'published',
    issue: mecaniqueEtmIssue,
  },
  {
    number: 7,
    slug: 'epi',
    themeCode: 'P',
    shortTitle: 'Les EPI',
    title: 'Casque, gants, blouson : non négociable',
    teaser: 'Tout sur les Équipements de Protection Individuelle, du minimum légal à l\'airbag.',
    accent: '#db2777',
    status: 'published',
    issue: epiEtmIssue,
  },
  {
    number: 8,
    slug: 'environnement',
    themeCode: 'E',
    shortTitle: 'L\'environnement',
    title: 'Rouler propre, rouler malin',
    teaser: 'Éco-conduite, bruit, pollution, ZFE — la moto responsable du XXIe siècle.',
    accent: '#15803d',
    status: 'published',
    issue: environnementEtmIssue,
  },
  {
    number: 9,
    slug: 'premiers-secours',
    themeCode: 'S',
    shortTitle: 'Premiers secours',
    title: 'Tu peux sauver une vie en 3 gestes',
    teaser: 'PAS (Protéger / Alerter / Secourir) — les gestes vitaux moto à connaître.',
    accent: '#b91c1c',
    status: 'published',
    issue: premiersSecoursEtmIssue,
  },
];

export const ETM_ISSUES_BY_SLUG = ETM_ISSUES_INDEX.reduce((acc, item) => {
  acc[item.slug] = item;
  return acc;
}, {});

export function getEtmIssueBySlug(slug) {
  const entry = ETM_ISSUES_BY_SLUG[slug];
  return entry?.issue || null;
}

export function getPublishedIssuesCount() {
  return ETM_ISSUES_INDEX.filter((i) => i.status === 'published').length;
}
